import axios from "../utils/axiosConfig";
import { AxiosError } from "axios";
import { Payment, PaymentFormData } from '../types/Payment';

import { handleApiError } from '../utils/apiErrorHandler';

const API_URL = '/api/payments';

function isAxiosError(error: any): error is AxiosError {
  return error && 'isAxiosError' in error && (error as AxiosError).isAxiosError === true;
}

export const paymentService = {
  // Alle Zahlungen abrufen
  getAllPayments: async (): Promise<Payment[]> => {
    try {
      const response = await axios.get(API_URL);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Fehler beim Abrufen der Zahlungen.');
      throw error;
    }
  },

  // Zahlung für eine bestimmte Meldungsbestätigung abrufen
  getPaymentByConfirmation: async (registrationConfirmationId: string): Promise<Payment | null> => {
    try {
      const response = await axios.get(`${API_URL}/confirmation/${registrationConfirmationId}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return null; // Keine Zahlung gefunden ist ein gültiger Fall
      }
      handleApiError(error, 'Fehler beim Abrufen der Zahlung.');
      throw error;
    }
  },

  // Zahlungen für einen bestimmten Wettbewerb abrufen
  getPaymentsByCompetition: async (competitionId: string): Promise<Payment[]> => {
    try {
      const response = await axios.get(`${API_URL}/competition/${competitionId}`);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Fehler beim Abrufen der Zahlungen nach Wettbewerb.');
      throw error;
    }
  },

  // Zahlung hinzufügen oder aktualisieren
  updatePayment: async (
    registrationConfirmationId: string, 
    paymentData: PaymentFormData
  ): Promise<Payment> => {
    try {
      const response = await axios.post(API_URL, {
        registrationConfirmationId,
        ...paymentData
      });
      return response.data;
    } catch (error) {
      handleApiError(error, 'Fehler beim Aktualisieren der Zahlung.');
      throw error;
    }
  },

  // Zahlung löschen
  deletePayment: async (paymentId: string): Promise<void> => {
    try {
      await axios.delete(`${API_URL}/${paymentId}`);
    } catch (error) {
      handleApiError(error, 'Fehler beim Löschen der Zahlung.');
      throw error;
    }
  }
};